import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
const Fail = () => {
  return <article data-sentry-component="Fail" data-sentry-source-file="index.tsx">
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Interview Result
      </Typography>
      <div className="relative p-5 bg-[#FFFBFA] rounded-lg flex gap-2 text-center items-center my-4 shadow-sm">
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className="absolute bottom-0 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
        <div className="z-10 flex flex-col items-center self-center gap-3 mx-auto text-center">
          <Typography variant="heading3" weight="semi-bold" className="!text-[#D92D20]" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            Interview Failed
          </Typography>
          <div className="flex flex-col items-center self-center gap-1">
            <Typography variant="regular" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              Unfortunately, You Did Not Qualify This Time!
            </Typography>
            <Typography variant="regular" className="!text-sm " data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              We regret to inform you that you have not been successful in clearing the interview
              stage of the admission process at this time.
            </Typography>
          </div>
        </div>
        <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/7fc697aa-79f3-43ba-85bc-818acc5d6653.svg" alt="heart-broken" width={120} height={120} className=" absolute bottom-0 right-4 w-[80px] h-[70px] sm:!w-[120px] sm:!h-[120px]" data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </div>
    </article>;
};
export default Fail;